export interface AvailabilityTooltipInput {
	hasPriceAgreement: boolean;
	status: string;
	dddSharePercent: number;
	dddShareThreshold: number;
	puhr1: string | null | undefined;
	dnc: string | null | undefined;
}

export function getAvailabilityTooltip({
	hasPriceAgreement,
	status,
	dddSharePercent,
	dddShareThreshold,
	puhr1,
	dnc,
}: AvailabilityTooltipInput): string {
	if (!hasPriceAgreement) {
		return 'LP je považován za nedostupný, pokud nebylo uzavřeno písemné ujednání o nejvyšší ceně výrobce nebo o úhradě.';
	}
	if (status === 'unavailable') {
		return `LP je považován za nedostupný, pokud jeho podíl ve skupině ATC a RS nedosáhne alespoň ${dddShareThreshold} % z celkového počtu.`;
	}
	if (dddSharePercent >= dddShareThreshold) {
		return `LP je považován za dostupný, pokud jeho podíl v kombinaci ATC a RS dosáhne alespoň ${dddShareThreshold} % z celkového počtu.`;
	}
	if (puhr1 === 'U') {
		return 'LP je považován za dostupný, pokud pole PUHR1 ve SCAU obsahuje hodnotu "U".';
	}
	if (dnc === 'X' || dnc === 'Y') {
		return 'LP je považován za dostupný, pokud pole DNC ve SCAU obsahuje hodnotu "X" nebo "Y".';
	}
	return 'LP je považován za dostupný.';
}
